var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalad(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 54.20049,
    viewBox: "0 0 60 54.20049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea5a47;}.cls-2{fill:#fff;}.cls-3{fill:#d0cfce;}.cls-4{fill:#b1cc33;stroke:#b1cc33;stroke-miterlimit:10;}.cls-4,.cls-5{stroke-width:2px;}.cls-5{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.4,29.80049l5-.8-.3-1c1.57813-.40042,2.53285-2.00436,2.13242-3.58249-.00999-.03939-.02081-.07857-.03242-.11752-.24091-.88638-.86401-1.61944-1.7-2,.76693-.86972,1.2129-1.97585,1.2637-3.1343,.03712-.93364-.19314-1.85846-.6637-2.6657-1.17203-1.95488-3.49946-2.89402-5.7-2.3,.42614-1.57904-.50846-3.20457-2.08751-3.63071-.39504-.10661-.80788-.1302-1.21249-.06929,.54325-2.69495-1.20105-5.32004-3.89601-5.86328-1.68436-.33953-3.42473,.21361-4.60399,1.46328-.26783-1.04971-1.06387-1.88367-2.1-2.2-.89867-.18683-1.83473-.00682-2.6,.5-.67046-2.02761-2.56441-3.3977-4.7-3.4-2.2989-.03252-4.30415,1.55497-4.8,3.8-.72958-.80673-1.85999-1.11857-2.9-.8-.88638,.24091-1.61944,.86401-2,1.7-1.60106-1.43117-3.93988-1.67312-5.8-.6-1.95488,1.17203-2.89402,3.49946-2.3,5.7-1.57904-.42614-3.20457,.50846-3.63071,2.08751-.10661,.39504-.1302,.80788-.06929,1.21249-2.69495-.54325-5.32004,1.20105-5.86329,3.89601-.33953,1.68436,.21361,3.42473,1.46328,4.60399-1.60854,.37349-2.60975,1.98024-2.23627,3.58878,.24955,1.07478,1.07073,1.92477,2.13627,2.21122v1l3.1,.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.6972,
    cy: 23.50069,
    r: 5.9998
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 30.6972,
    cy: 22.50069,
    r: 5.9998
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45.6972,
    cy: 22.50069,
    r: 5.9998
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59,24.20049c0,16.01626-12.98374,29-29,29S1,40.21675,1,24.20049H59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43,24.20049c0,16-4,29-13,29,16.01151-.01147,28.98853-12.98849,29-29h-16Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.2693,17.40269c.97581-.28034,2.01262-.26667,2.9807,.0393,.98878,.32443,1.8727,.90761,2.56,1.689"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.2771,18.42939c.81982-.64108,1.79633-1.05097,2.8281-1.1871,1.00793-.12203,2.02947,.056,2.9367,.5118"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M11.5841,20.13099c.68732-.78136,1.57123-1.36454,2.56-1.689,.96804-.30597,2.00483-.31964,2.9806-.0393"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.6508,20.13639c.26823-1.20594,.07153-2.46869-.5508-3.5359-1.17203-1.95489-3.49946-2.89402-5.7-2.3,.42614-1.57904-.50846-3.20457-2.08751-3.63071-.39504-.10661-.80788-.1302-1.21249-.06929,.54325-2.69495-1.20105-5.32004-3.89601-5.86328-1.68436-.33953-3.42473,.21361-4.60399,1.46328-.26783-1.04971-1.06387-1.88367-2.1-2.2-.89867-.18683-1.83473-.00682-2.6,.5-.67046-2.02761-2.56441-3.3977-4.7-3.4-2.2989-.03252-4.30415,1.55497-4.8,3.8-.72958-.80673-1.85999-1.11857-2.9-.8-.88638,.24091-1.61944,.86401-2,1.7-1.60106-1.43117-3.93988-1.67312-5.8-.6-1.95489,1.17203-2.89402,3.49946-2.3,5.7-1.57904-.42615-3.20457,.50846-3.63072,2.08751-.10661,.39504-.1302,.80788-.06929,1.21249-2.09683-.40459-4.22085,.55723-5.3,2.4-.51592,.86901-.74153,1.87979-.6441,2.8857"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59,24.20049c0,16.01626-12.98374,29-29,29S1,40.21675,1,24.20049H59Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalad);
export default __webpack_public_path__ + "static/media/salad.f6ce98ece508dcdeeba9f486b95d7497.svg";
export { ForwardRef as ReactComponent };